function PercentageFilter (numeral) {
  function filter (value) {
    let v = value / 100
    return numeral(v).format('0,0.00') + '%'
  }

  return {
    filter
  }
}

export default PercentageFilter
